import React, { useEffect, useState } from 'react';
import Table from '@awp/components/table';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { Permissions, FORM_MODE, REST_API } from '@awp/constants';
import { DeleteJson } from '@awp/helpers/fetchReact';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import Authorize from '@awp/components/Authorize';
import { hasAccess } from '@components/Authorize';
import { ActionMenuView, ActionMenuEdit, ActionMenuDelete } from '@awp/components/Common/AwpActionMenus';
import AwpYesNoModal from '@components/Common/AwpYesNoModal';
import { toast } from 'react-toastify';
import { useVMSContext } from './VmsContext';
import VmsService from '@components/VariableMessageSigns/VmsService';

const VmsTable = () => {
  const {
    setMode,
    mode,
    isMedium,
    isLarge,
    data,
    setData,
    loading,
    setVms,
    search,
    setSearch,
    filteredData,
    setFilteredData,
  } = useVMSContext();

  const [showYesNoModal, setShowYesNoModal] = useState(false);
  const [vmsId, setVmsId] = useState(null);

  const crudService = new VmsService(mode);

  const actionMenu = (row) => {
    return (
      <>
        <div>
          <Authorize requires={[Permissions.WriteVms]}>
            <ActionMenuEdit
              onClick={() => {
                setMode(FORM_MODE.EDIT);
                setVms(row.row.original);
              }}
            />
          </Authorize>
          <ActionMenuView
            onClick={() => {
              setMode(FORM_MODE.VIEW);
              setVms(row.row.original);
            }}
          />
          <Authorize requires={[Permissions.WriteVms]}>
            <ActionMenuDelete
              onClick={() => {
                setVmsId(row.row.original.Id);
                setShowYesNoModal(true);
              }}
            />
          </Authorize>
        </div>
      </>
    );
  };
  const handleDelete = async () => {
    if (!vmsId) return;
    setShowYesNoModal(false);

    const url = REST_API.VMS + vmsId;

    const resp = await DeleteJson(url);
    if (resp.ok) {
      toast.success('Successfully deleted');
      let _data = [...data];
      let _removedData = [];
      _data.map((o) => {
        if (o.Id !== vmsId) {
          _removedData.push(o);
        }
      });
      setData([..._removedData]);
    } else {
      toast.error('Error occurred while deleting');
    }
  };
  // const hasSearch = (src) => {
  //   return src ? src.toLowerCase().includes(search.toLowerCase()) : false;
  // };
  // useEffect(() => {
  //   let filtered = [...data];
  //   if (!isValueEmpty(search)) {
  //     filtered = filtered.filter((man) => hasSearch(man.Name) || hasSearch(man.Note));
  //   }

  //   setFilteredData(filtered);
  // }, [search]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'Name',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Location',
        accessor: 'Location',
        sortType: sortByNumericThenAlpha,
        Cell: (c) => {
          return <div className="text-wrap">{c.value}</div>;
        },
      },
      {
        Header: 'State Key',
        accessor: 'StateKey',
        sortType: sortByNumericThenAlpha,
        Cell: (c) => {
          return <div className="text-wrap">{c.value}</div>;
        },
      },
      {
        Header: 'Weather Station',
        accessor: 'WeatherStationId',
        sortType: (rowA, rowB, id) => {
          let valA = '';
          let valB = '';
          if (rowA.original && rowA.original.WeatherStationNumber) {
            valA = rowA.original.WeatherStationNumber;
          }

          if (rowB.original && rowB.original.WeatherStationNumber) {
            valB = rowB.original.WeatherStationNumber;
          }

          return valA.localeCompare(valB);
        },
        Cell: (c) => {
          if (c && c.row && c.row.original) {
            const r = c.row.original;
            return <div className="text-wrap">{r.WeatherStationNumber + ' - ' + r.WeatherStationName}</div>;
          }
          return '';
        },
      },
      {
        Header: 'Status',
        accessor: 'IsActive',
        sortType: sortByNumericThenAlpha,
        Cell: (c) => {
          if (c && c.row && c.row.original) {
            const r = c.row.original.IsActive === 'Y' ? 'Active' : 'Inactive';
            return <div className="text-wrap">{r}</div>;
          }
          return '';
        },
      },
      {
        Header: 'Actions',
        accessor: 'Id',
        disableSortBy: true,
        Cell: actionMenu,
      },
    ],
    [isLarge, isMedium],
  );

  return (
    <>
      <div className="d-flex">{crudService.crud.getHeader()}</div>

      <Table columns={columns} data={data} fetchData={() => {}} loading={loading} search="" defaultSortBy="Name" />
      {hasAccess([Permissions.WriteVms]) && (
        <div className="my-3">
          <Row>
            <Col sm={3} md={4}>
              <Button
                className="mr-2 my-3"
                variant="primary"
                onClick={() => {
                  setMode(FORM_MODE.CREATE);
                }}
                disabled={loading}
              >
                {'Create Variable Message Sign'}
              </Button>
            </Col>
          </Row>
        </div>
      )}
      <AwpYesNoModal
        showYesNoModal={showYesNoModal}
        setShowYesNoModal={setShowYesNoModal}
        onClickYes={handleDelete}
        title="Delete VMS record"
        body="Are you sure to delete this VMS record? Deleted VMS record can't be recovered."
      />
    </>
  );
};

export default VmsTable;
